import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Box } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import { Link } from '@src/components/Link'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'

const useStyles = makeStyles((theme: Theme) => {
  return {
    stepNumber: {
      fontSize: theme.typography.pxToRem(12),
    },
    leftNavigation: {
      color: theme.palette.common.black,
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(8),
    },
    stepLabel: {
      fontSize: theme.typography.pxToRem(18),
    },
    cursor: {
      cursor: 'pointer',
    },
    activelink: {
      color: theme.palette.common.black,
      '& hr': {
        backgroundColor: theme.palette.common.black,
      },
    },
    completedLink: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      '& hr': {
        backgroundColor: theme.palette.grey[400],
      },
      '&:hover': {
        backgroundColor: 'inherit',
        color: theme.palette.primary.dark,
      },
    },
    disabledLink: {
      pointerEvents: 'none',
      color: theme.palette.grey[500],
    },
  }
})

export enum NavigationStepStatus {
  DISABLED = 'DISABLED',
  COMPLETED = 'COMPLETED',
  ACTIVE = 'ACTIVE',
}

export interface SidebarItem {
  url?: string
  label: string
  activeLink?: boolean
  completed?: boolean
  linkDisable?: boolean
}
export interface LeftNavigationProps {
  sidebarItems: SidebarItem[]
}
const LeftNavigation: React.FC<LeftNavigationProps> = ({ sidebarItems }) => {
  const classes = useStyles()
  return (
    <Box>
      {sidebarItems.map((item, index) => {
        const kmskey = `CONF_PEPSCREEN_STEP${index + 1}`
        return (
          <Link href={item.url!} passHref key={index}>
            <div
              className={clsx(classes.leftNavigation, {
                [classes.activelink]: item.activeLink,
                [classes.completedLink]: !item.activeLink && !item.linkDisable,
                [classes.disabledLink]: item.linkDisable,
              })}
            >
              <span className={classes.stepNumber}>
                {messages[kmskey] ? (
                  <FormattedMessage {...messages[kmskey]} />
                ) : (
                  <FormattedMessage
                    {...messages.CONF_NGSO_STEPS}
                    values={{ stepNo: index + 1 }}
                  />
                )}
              </span>
              <Divider color="primary" />
              <span className={clsx(classes.stepLabel)}>{item.label}</span>
            </div>
          </Link>
        )
      })}
    </Box>
  )
}

export default LeftNavigation
